<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>年货管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate">新增</el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" border>
        <el-table-column prop="bannerName" align="center" label="年货名称"></el-table-column>
        <el-table-column prop="imageUrl" align="center" label="年货图片">
          <template slot-scope="scope">
            <div class="table-thumbnail">
              <el-image :src="scope.row.imageUrl" fit="contain" alt="" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" align="center" label="商品名称"></el-table-column>
        <el-table-column prop="goodsPicture" align="center" label="商品图片">
          <template slot-scope="scope">
            <div class="table-thumbnail">
              <el-image :src="scope.row.goodsPicture" fit="contain" alt="" />
            </div>
          </template>
        </el-table-column>

        <el-table-column label="是否显示年货" prop="openBanner" align="center">
          <template slot-scope="scope">
            <el-switch :value="scope.row.status == 1" active-color="#13ce66" inactive-color="#ff4949" @change="statusChange(scope.row.bannerId, scope.row.status)"> </el-switch>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.bannerId)">
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="resetDialogForm" :close-on-click-modal="false">
      <div>
        <el-form ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="120px">
          <el-form-item label="年货名称 ：" prop="bannerName">
            <el-input v-model.trim="itemParams.bannerName" size="small" placeholder="请输入年货名称"></el-input>
          </el-form-item>
          <el-form-item label="年货图片：" prop="imageUrl">
            <div class="thumbnail-img">
              <i class="el-icon-circle-plus-outline upload-icon"></i>
              <input type="file" class="hidden-upload" @change="doUpload" id="uploadDom" />
              <img v-if="itemParams.imageUrl" :src="itemParams.imageUrl" alt="" class="thumbnail-img-wrapped" />
            </div>
          </el-form-item>
          <el-form-item label="领货日期：">
            <el-select clearable style="width: 100%" v-model="itemParams.plaSupplyDateId" placeholder="请选择领货日期" size="small" @change="dateChange">
              <el-option v-for="item in dateList" :value="item.id" :key="item.id" :label="item.title"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择商品 ：" prop="goodId">
            <el-select v-model="itemParams.goodId" filterable remote :remote-method="loadGoodsList" placeholder="请输入商品名称搜索">
              <el-option v-for="item in goodsList" :key="item.goodId" :label="item.goodName" :value="item.goodId"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button :loading="isDisabled" :disabled="isDisabled" size="small" type="primary" @click="saveCategoryNameItem('dialogForm')">保 存</el-button>

            <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import md5 from "js-md5";

import Vue from "vue";
export default {
  data() {
    return {
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogTitle: "",
      dialogVisible: false,
      url: "",
      itemParams: {
        bannerName: "",
        imageUrl: "",
        goodId: "",
        plaFarmStockId: "",
        plaSupplyDateId: "",
      },
      bodyParams: {},
      checkItemParams: {
        bannerName: [{ required: true, message: "请输入传年货名称", trigger: "blur" }],
        imageUrl: [{ required: true, message: "请上传年货图片", trigger: "blur" }],
        goodId: [{ required: true, message: "请选择商品", trigger: "blur" }],
      },
      isDisabled: false,
      status: 0, // 0 -- 新增; 1 -- 编辑
      listParams: {
        supplyId: "",
      },
      dateList: [],
      goodsList: [],
    };
  },
  mounted() {
    this.listParams.supplyId = parseInt(this.$route.params.supplyId);

    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/banner/getBannerList",
        method: "GET",
        params: {
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              const resData = res.body.data.dataList;
              const newResData = resData.map(item => {
                return Object.assign({}, item, {
                  goodsPicture: item.goodsPicture.split(",")[0],
                });
              });

              this.tableData = newResData;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
              this.pager.total = 0;
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 新增年货管理
     */
    toCreate() {
      this.status = 0;
      this.dialogTitle = "新增年货管理条目";
      this.dialogVisible = true;
      this.itemParams.bannerName = "";
      this.itemParams.imageUrl = "";
      this.itemParams.goodId = "";
      this.itemParams.plaFarmStockId = "";
      this.itemParams.plaSupplyDateId = "";
      this.url = global.apiUrl + "/banner/saveBanner";
      if (this.itemParams.bannerId) {
        delete this.itemParams.bannerId;
      }
      this.loadDateList();
    },
    /**
     * 保存新增或修改
     * @param name
     */
    saveCategoryNameItem(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.isDisabled = true;

          let bodyParams = {};
          if (this.itemParams.bannerId) {
            bodyParams = Object.assign({}, bodyParams, this.itemParams);
          } else {
            const goodsItem = this.goodsList.find(item => this.itemParams.goodId == item.goodId);

            bodyParams = Object.assign({}, bodyParams, {
              bannerName: this.itemParams.bannerName,
              imageUrl: this.itemParams.imageUrl,
              goodId: this.itemParams.goodId,
              plaFarmStockId: goodsItem.plaFarmStockId,
              plaSupplyDateId: this.itemParams.plaSupplyDateId,
            });
          }
          this.$http({
            url: this.url,
            method: this.itemParams.bannerId ? "PUT" : "POST",
            body: bodyParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.dialogVisible = false;
                this.isDisabled = false;
                this.$message.success(res.body.info);
                this.loadTableData();
              } else {
                this.isDisabled = false;
              }
            })
            .catch(err => {
              this.isDisabled = false;

              console.error(err);
            });
        }
      });
    },
    dateChange() {
      this.itemParams.goodId = "";
      this.goodsList = [];
      this.loadGoodsList();
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
    /**
     * 更新状态
     */
    statusChange(bannerId, status) {
      this.$http({
        url: global.apiUrl + "/banner/updateStatus",
        method: "PUT",
        body: {
          bannerId,
          status: status == 1 ? 2 : 1,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 修改条目数据
     * @param row
     */
    editItem(row) {
      this.status = 1;
      this.dialogTitle = "编辑年货管理条目";
      this.url = global.apiUrl + "/banner/updateBanner";
      Object.assign(this.itemParams, row);
      this.dialogVisible = true;
      this.loadDateList();
      this.loadGoodsList();
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/banner/deleteBanner/" + id,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化领货日期
     */
    loadDateList() {
      this.$http({
        url: global.apiUrl + "/supply/goodputsale/supplyDate/findAll",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              if (res.body.data.length > 0) {
                this.dateList = res.body.data;
              } else {
                this.dateList = [];
                this.itemParams.plaSupplyDateId = "";
              }
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 获取商品列表
     */
    loadGoodsList(goodName) {
      this.$http({
        url: global.apiUrl + "/banner/getGoodsList",
        method: "GET",
        params: {
          goodName: goodName,
          plaSupplyId: this.listParams.supplyId,
          plaSupplyDateId: this.itemParams.plaSupplyDateId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.goodsList = res.body.data;
            } else {
              this.goodsList = [];
            }
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 上传图片
     */
    doUpload() {
      const files = document.getElementById("uploadDom").files;
      const file = files[0];

      const params = new FormData();
      params.append("file", file);
      params.append("path", "upload/ad-img");
      Vue.ajaxPost(this, global.apiImageUpload + "/oss/image/upload", params, { "Content-Type": "multipart/form-data" })
        .then(res => {
          this.uploading = false;
          this.itemParams.imageUrl = res.data.data;
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
.table-thumbnail {
  width: 100px;
  margin: 0 auto;
}
.thumbnail-img {
  width: 100px;
  height: 50px;
  border: 1px solid #ebeef5;
  position: relative;
  overflow: hidden;
  .upload-icon {
    font-size: 20px;
    display: inline-block;
    margin-top: 15px;
    margin-left: 40px;
  }
  .hidden-upload {
    cursor: pointer;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    filter: alpha(opacity=0); //filter 过滤器   兼容IE678
    z-index: 9999;
  }
  .thumbnail-img-wrapped {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
}
</style>
